import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../shared/services/shared.service';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../auth/auth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-play-golf-landing',
    imports: [
        CommonModule
    ],
    templateUrl: './play-golf-landing.component.html',
    styleUrl: './play-golf-landing.component.scss'
})
export class PlayGolfLandingComponent implements OnInit {
  isLoggedIn = false;
  constructor(
    private _authService: AuthService,
    private _router: Router
  ) { }
  ngOnInit(): void {
     this.isLoggedIn = this._authService.isSignedIn();
  }
  openAuthModal(type = 'login') {
    this._router.navigate([type]);
  }
}
